// Botão "Preencher com a foto da nota" (leitura com IA, 0.16.0): aparece
// quando a despesa tem uma foto ou um PDF e o aparelho está com internet.
import { h } from '../lib/dom.js';
import { mensagemDeErro } from '../lib/erros.js';
import { lerNota, oQuePreencher, textoDoPreenchido, TIPOS_LIDOS } from '../lib/nota-ia.js';
import { sessao } from '../sessao.js';
import { avisar } from './componentes.js';

//   fotos(): as fotos novas da despesa ({ blob, mime }) · atuais(): o que está nos campos
//   categorias(): [{ id, codigo }] · preencher(oQue): põe os valores no formulário
export function botaoDeLerNota({ fotos, atuais, categorias, preencher }) {
  const botao = h('button', { class: 'botao secundario cheio ler-nota', type: 'button', hidden: true }, 'Preencher com a foto da nota');
  const legivel = () => fotos().find((f) => TIPOS_LIDOS.includes(f.mime));
  const atualizar = () => {
    botao.hidden = !legivel();
  };
  botao.addEventListener('click', async () => {
    const foto = legivel();
    if (!foto) return;
    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      avisar('Sem internet agora: preencha à mão (a foto fica guardada).', 'erro');
      return;
    }
    const texto = botao.textContent;
    botao.disabled = true;
    botao.textContent = 'Lendo a nota…';
    try {
      const campos = await lerNota({ foto, empresa: sessao.empresa.id });
      const oQue = oQuePreencher(campos, atuais(), categorias());
      preencher(oQue);
      avisar(textoDoPreenchido(oQue));
    } catch (erro) {
      avisar(mensagemDeErro(erro), 'erro');
    } finally {
      if (botao.isConnected) {
        botao.disabled = false;
        botao.textContent = texto;
      }
    }
  });
  return { botao, atualizar };
}
